import {
  SecondOpinionTypeActionTypes,
  SECOND_OPINION_TYPE_FAIL,
  SECOND_OPINION_TYPE_LOADING,
  SECOND_OPINION_TYPE_SUCCESS,
  SecondOpinionTypeState,
  SECOND_OPINION_TYPE_API_MSG,
  SECOND_OPINION_TYPE_API_RES,
} from "./ActionTypes";
import { SecondOpinionResponse } from "./Model";

const initialStateGetPosts: SecondOpinionTypeState = {
  loading: false,
  secondOpinionTypeRes: {} as SecondOpinionResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getSecondOpinionTypeListReducer = (
  state = initialStateGetPosts,
  action: SecondOpinionTypeActionTypes
): SecondOpinionTypeState => {
  switch (action.type) {
    case SECOND_OPINION_TYPE_LOADING:
      return {
        ...state,
        loading: true,
        secondOpinionTypeRes: {} as SecondOpinionResponse,
      };
    case SECOND_OPINION_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        secondOpinionTypeRes: action.payload,
        successMsg: action.successMsg,
        status: action.status
      };
    case SECOND_OPINION_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        secondOpinionTypeRes: {} as SecondOpinionResponse,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case SECOND_OPINION_TYPE_API_MSG:
      return {
        ...state,
        loading: false,
        secondOpinionTypeRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case SECOND_OPINION_TYPE_API_RES:
      return {
        ...state,
        loading: false,
        secondOpinionTypeRes: {} as SecondOpinionResponse,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
